const LOGIN_URLS = {
     LOGIN:"/auth/login",
     FORGOT_PASSWORD:"/auth/user_reset"
};

export {
    LOGIN_URLS
}